import { gql } from '@apollo/client';
const GET_PRODUCT_COUNTRIES = gql `
  query GetProductCountries($first: Int = 25, $after: String = "", $continentId: ID) {
    autocomplete {
      productCountries(first: $first, after: $after, continentId: $continentId) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            name
            description
            thumbnail
            continent {
              id
              name
            }
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_COUNTRIES;
